// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
export const STROLLER_QUESTION_PLACEHOLDER = "Tvoja ot\u00e1zka";
